export class P4Failure {
    static COLUMN_IS_FULL = () => $localize `Please put your piece in an incomplete column.`;
}
